import { IAppState } from './appState';

export default {
  UPDATE_WINDOW_WIDTH( state: IAppState, val: number ) {
    state.windowWidth = val
  },
  TOGGLE_OVERLAY( state: IAppState, val: boolean ) {
    state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
  },
};